import React, {PureComponent} from 'react';
import cn from "classnames"
import LinkButton from "../Widgets/LinkButton"
import DropDown from "../Widgets/SingleDropDown"
import { connect } from 'kea'
import {NEWSLETTER_OPTIONS, formInPage} from './formFooter'

//TODO This is a duplicate of the form.js file, should only need one but for some reason when it is rendered bu SSR it isn;t working properly
@connect({
    actions: [
        formInPage, [
            'setValue',
            'submit'
        ]
    ],
    props: [
        formInPage, [
            'values',
            'isSubmitting',
            'errors',
            'submitError'
        ]
    ]
})
class NewsletterForm extends PureComponent {

    componentDidMount() {}

    render() {

        const {
          classes, classNames={}, id, isSubmitting,
          errors, values, submitError,
          submitText = 'Submit'
        } = this.props
        const { submit, setValue } = this.actions
        const { gender, email } = values

        return (
        <div className={cn(classes.root, classNames.root)}>
            <div className={cn(classes.fields, classNames.fields)}>
              <div className={cn(classes.formFieldRow, classes.gender, classNames.gender)}>
                  <DropDown id={`newsletter-gender-${id}`}
                            className={cn( classes.formField, classes.formFont, classes.dropDownContainer)}
                            chevronCaret={true}
                            options={NEWSLETTER_OPTIONS}
                            value={gender}
                            label={gender}
                            dropDownClassName={cn(classes.dropDown, classNames.dropDown)}
                            dropDownHeight="auto"
                            caretClassName={classes.dropDownCaret}
                            onChange={value => setValue('gender', value)}/>
                  {errors.gender ? <div className={classes.error}>{errors.gender}</div> : null}
              </div>

              <div className={cn(classes.formFieldRow, classes.email, classNames.email)}>
                <input type="email" name="email" placeholder="Your email address"
                      className={cn(classes.formField, classes.formFont, classes.input, classNames.emailInput)}
                      onChange={e => setValue('email', e.target.value)} value={email} />
                {errors.email || submitError ? <div className={cn(classes.error, classNames.error)}>{errors.email || submitError}</div> : null}
              </div>
            </div>

            <div className={cn(classes.actions, classNames.actions)}>
                <LinkButton onClick={submit} loading={isSubmitting} className={cn(classes.link, classNames.link)} >{isSubmitting ? 'Submitting...' : submitText}</LinkButton>
            </div>
        </div>
        );
    }
}

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/components/Newsletter/NewsletterForm.js